import {
  Button,
  Typography
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { StyledNominaMasivaErrorDialog } from "../../styled/Personal";

const ErrorDialog = ({ open, handleClose, errors }) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>El archivo contiene los siguientes errores</DialogTitle>
      <StyledNominaMasivaErrorDialog.ContainerBody>
        <ul>
          {errors.map((err) => (
            <li>
              <Typography key={err.key}>{err.error}</Typography>
            </li>
          ))}
        </ul>
      </StyledNominaMasivaErrorDialog.ContainerBody>
      <StyledNominaMasivaErrorDialog.ContainerButton>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleClose}
        >
          Cerrar
        </Button>
      </StyledNominaMasivaErrorDialog.ContainerButton>
    </Dialog>
  );
};

export default ErrorDialog;
